import * as React from 'react';
import { Skeleton as ShadcnSkeleton } from 'vendor/shadcn/components/ui/skeleton';
import { cn } from '@shadcn/lib/utils';

export function Skeleton({ className, ...props }: React.ComponentProps<typeof ShadcnSkeleton>) {
  return <ShadcnSkeleton className={cn('bg-muted', className)} {...props} />;
}
